let global = {
  local_url: '//test-api.live.offcncloud.com/api/v1',
  test_url: '//test-api.live.offcncloud.com/api/v1',
  online_url: '//api.live.offcncloud.com/api/v1',
  mall_local: '//live.t.eoffcn.com/api/adm',
  mall_test_url: '//live.t.eoffcn.com/api/adm',
  mall_online_url: '//live.eoffcn.com/api/adm',
  live_goods_test: 'https://erp.t.eoffcn.com/api/live_goods',
  live_goods_online: 'https://erp.eoffcn.com/api/live_goods'
}

export {
  global
}



// WEBPACK FOOTER //
// ./src/common/api/api.config.js